import { BotProviderStatisticsChatCounts, BotProviderStatisticsTokenUsage, TokenUsageData, TokenUsageDataWithModel } from "@/API";

export function SumChatCountsData(data: BotProviderStatisticsChatCounts): number {
    return Object.values(data).reduce((sum, item) => sum + (item ?? 0), 0)
}
export function LogChatCountsData(data: BotProviderStatisticsChatCounts): string {
    var log = ""
    for (const key in data) {
        const value = data[key];
        log += `${key}: ${value}\n`
    }
    return log.trim()
}
export function SumTokenUsageData(data: BotProviderStatisticsTokenUsage): TokenUsageData {
    return {
        inputTokens: Object.values(data).reduce((sum, item) => sum + (item.inputTokens ?? 0), 0),
        outputTokens: Object.values(data).reduce((sum, item) => sum + (item.outputTokens ?? 0), 0),
    }
}
export function LogTokenUsageData(data: BotProviderStatisticsTokenUsage): string {
    var log = ""
    for (const key in data) {
        const value = data[key];
        log += `${key}: ${value.inputTokens} / ${value.outputTokens}\n`
    }
    return log.trim()
}
export function SumTokenUsageDataWithModel(data: TokenUsageDataWithModel[]): TokenUsageData {
    return {
        inputTokens: data.reduce((sum, item) => sum + item.inputTokens, 0),
        outputTokens: data.reduce((sum, item) => sum + item.outputTokens, 0),
    }
}

export function GroupTokenUsageByModel(data: TokenUsageDataWithModel[]): TokenUsageDataWithModel[] {
    const map = new Map<string, { inputTokens: number; outputTokens: number }>();
    for (const item of data) {
        const model = item.model || "Unknown";
        const current = map.get(model) || { inputTokens: 0, outputTokens: 0 };
        current.inputTokens += item.inputTokens ?? 0;
        current.outputTokens += item.outputTokens ?? 0;
        map.set(model, current);
    }
    return Array.from(map.entries()).map(([model, usage]) => ({
        model,
        inputTokens: usage.inputTokens,
        outputTokens: usage.outputTokens,
    }));
}
